import styles from './controls.module.scss'
import { WarningIcon } from './SeriesIcons'

type RowWarningProps = { messages: string[]; refused: boolean }

export const RowWarning = ({ messages, refused }: RowWarningProps) => {
  if (messages.length === 0) return null
  return (
    <div className={refused ? `${styles.warn} ${styles.refused}` : styles.warn}>
      <WarningIcon />
      {messages.map((message) => (
        <span key={message}>{message}</span>
      ))}
    </div>
  )
}
